import type { Page } from '@/domain/model/Page';
import type { CadenciaConfig, UpsertCadenciaConfigCommand } from '@/domain/model/CadenciaConfig';
import type { CadenciaGateway, ListCadenciasParams } from '@/application/port/out/CadenciaGateway';
import type {
  ListCadenciasUseCase, CreateCadenciaUseCase, UpdateCadenciaUseCase, DeleteCadenciaUseCase,
} from '@/application/port/in/CadenciaUseCase';

export class ListCadencias implements ListCadenciasUseCase {
  constructor(private readonly g: CadenciaGateway) {}
  execute(params: ListCadenciasParams): Promise<Page<CadenciaConfig>> { return this.g.list(params); }
}
export class CreateCadencia implements CreateCadenciaUseCase {
  constructor(private readonly g: CadenciaGateway) {}
  execute(cmd: UpsertCadenciaConfigCommand): Promise<CadenciaConfig> { return this.g.create(cmd); }
}
export class UpdateCadencia implements UpdateCadenciaUseCase {
  constructor(private readonly g: CadenciaGateway) {}
  execute(id: string, cmd: UpsertCadenciaConfigCommand): Promise<CadenciaConfig> { return this.g.update(id, cmd); }
}
export class DeleteCadencia implements DeleteCadenciaUseCase {
  constructor(private readonly g: CadenciaGateway) {}
  execute(id: string): Promise<void> { return this.g.remove(id); }
}
